import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "question", "answer","previousButton", "nextButton", "progressBar", "result", "promoBanner" ]

  initialize() {
    this.showCurrentQuestion()
    this.answerListeners()
  }

  nextPage() {
    this.index++
  }

  previousPage() {
    this.index--
  }

  answerListeners() {
    this.answerTargets.forEach((answer, i) => {
      answer.addEventListener( 'change', this.answerHandler.bind(this))
    })
  }

  answerHandler(event) {
    // Define which Button will reset all other answers
    var resetAnswersButton = this.questionTargets[this.index].querySelector("[data-reset='true']")

    if (event.target.type == "checkbox") {
      if (event.target == resetAnswersButton) {
        this.uncheckOtherAnswers()
      } else {
        resetAnswersButton.checked = false
      }
    }

    this.nextStepChecker()
  }

  // Uncheck all Answers that don't have the data attribute 'reset' set to 'true'
  uncheckOtherAnswers() {
    this.questionTargets[this.index].querySelectorAll("[data-target='assessment.answer']").forEach((answer, i) => {
      if (answer.checked && !answer.dataset.reset) {
        answer.checked = false
      }
    })
  }

  get index() {
    return parseInt(this.data.get("index"))
  }

  set index(value) {
    this.data.set("index", value)
    this.showCurrentQuestion()
  }

  showCurrentQuestion() {
    if (this.index == 0) {
      this.startState()
    } else if (this.index == this.questionTargets.length - 1) {
      this.finishedState()
    } else {
      this.ongoingState()
    }

    this.updateProgressBar()
    this.nextStepChecker()

    this.questionTargets.forEach((el, i) => {
      el.classList.toggle("zzform__question--current", this.index == i)
    })

    window.scrollTo(0, 0)
  }

  startState() {
    this.nextButtonTarget.textContent = "Selbsttest starten"
    this.previousButtonTarget.style.display = "none"
  }

  finishedState() {
    this.nextButtonTarget.style.display = "none"
    this.previousButtonTarget.style.display = "none"
    this.promoBannerTarget.style.display = "block"
    this.calculateTotal()
  }

  ongoingState() {
    this.nextButtonTarget.textContent = "Weiter"
    this.previousButtonTarget.style.display = "block"
  }

  updateProgressBar() {
    this.progressBarTarget.value = (100 / this.questionTargets.length + 1) * this.index
  }

  nextStepChecker() {
    if (this.index == 0 || this.questionTargets[this.index].querySelectorAll("[data-target='assessment.answer']:checked").length > 0) {
      this.nextButtonTarget.disabled = false
    } else {
      this.nextButtonTarget.disabled = true
    }
  }

  calculateTotal() {
    var score = 0
    var answers = document.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')

    answers.forEach((answer, i) => {
      score = parseInt(answer.dataset.weight) + score
    })

    if (score < 3) {
      this.resultTargets[0].style.display = "block"
      this.resultTargets[1].style.display = "none"
    } else if (score >= 3) {
      this.resultTargets[0].style.display = "none"
      this.resultTargets[1].style.display = "black"
    }
  }
}
